import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobVacancy } from '../../Model/JobVacancy';

export interface ItemProps {
    model: JobVacancy;
    selected: boolean;
}

export abstract class AbstractItem extends React.PureComponent<ItemProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    protected renderIndicator(props: ItemProps) {
        const title = this.context.i18n.translate('Diese Stelle ist für die Bewerbung markiert');

        if (props.selected) {
            return <span className="jc-indicator -inline -selected" title={title}>
                <i className="far fa-check"/>
            </span>;
        } else {
            return <span className="jc-indicator -inline" title={title}>&nbsp;</span>;
        }
    }
}
